import { EntityType } from '../components/DTStudio/interfaces'

/**
 * Depth-first lookup of a template's `treePath` by id in the (nested) org
 * template tree. Returns '' when the id is absent so callers can safely
 * `.includes(...)` the result. Used to recognise which abstract root a template
 * descends from (e.g. the Device root) without depending on tree depth.
 */
export const findTreePathById = (
    list: EntityType[] | undefined,
    id: string,
): string => {
    if (!list?.length || !id) {
        return ''
    }
    for (const node of list) {
        if (node.id === id) {
            return node.treePath || ''
        }
        const found = findTreePathById(node.subEntityTypes, id)
        if (found) {
            return found
        }
    }
    return ''
}

export const getNoHideEntityList = (list: EntityType[]): EntityType[] => {
    let updatedList: EntityType[] = []
    for (const i of list) {
        if (i.isHidden) {
            if (i.subEntityTypes?.length) {
                const subList = getNoHideEntityList(i.subEntityTypes)
                updatedList = [...updatedList, ...subList]
            }
        } else {
            updatedList = [...updatedList, i]
        }
    }
    return updatedList
}

// UBQ-5606: the side-nav list drops hidden templates, which also hides Shipment from the bulk
// upload picker when Shipment is marked Hidden (prod, dev1). Bulk upload keeps that list and
// appends the org's shipment templates, identified by the "shipment template" settings row
// rather than by name, so a hidden Shipment stays uploadable without unhiding it in navigation.
export const appendShipmentTemplates = (
    list: EntityType[],
    fullTree: EntityType[],
    shipmentTemplateIds: string[],
): EntityType[] => {
    if (!shipmentTemplateIds.length) {
        return list
    }
    const wanted = new Set(shipmentTemplateIds)
    const present = new Set(list.map((t) => t.id))
    const missing: EntityType[] = []
    const walk = (nodes: EntityType[]): void => {
        for (const node of nodes) {
            if (wanted.has(node.id) && !present.has(node.id)) {
                present.add(node.id)
                missing.push(node)
            }
            if (node.subEntityTypes?.length) {
                walk(node.subEntityTypes)
            }
        }
    }
    walk(fullTree)
    return [...list, ...missing]
}
